import YouTube from "react-youtube";
import styled from "styled-components";
import { useState, useRef } from "react";
import { formatYoutubeURL } from "../../../utils/formatter/formatYoutubeURL.util";
import SoundOnIcon from "../../../assets/svg/sound_on.svg";
import SoundOffIcon from "../../../assets/svg/sound_off.svg";

interface YoutubeSectionProps {
  youtubeUrl: string;
  onPlay?: () => void;
  onEnd?: () => void;
}

export const YoutubeSection = ({
  youtubeUrl,
  onPlay,
  onEnd,
}: YoutubeSectionProps) => {
  const [isMuted, setIsMuted] = useState(true);
  const playerRef = useRef<any>(null);

  const opts = {
    playerVars: {
      autoplay: 1,
      mute: 1,
      controls: 1,
      rel: 0,
      modestbranding: 1,
      playsinline: 1,
    },
  };

  const handleReady = (event: any) => {
    playerRef.current = event.target;
  };

  const toggleMute = () => {
    if (playerRef.current) {
      if (isMuted) {
        playerRef.current.unMute();
        setIsMuted(false);
      } else {
        playerRef.current.mute();
        setIsMuted(true);
      }
    }
  };

  return (
    <>
      <YouTubeWrapper>
        <CustomYoutube
          videoId={formatYoutubeURL(youtubeUrl)}
          opts={opts}
          onReady={handleReady}
          onPlay={onPlay && (() => onPlay())}
          onEnd={onEnd && (() => onEnd())}
        />
      </YouTubeWrapper>
      <SoundButton onClick={toggleMute}>
        <img
          src={isMuted ? SoundOffIcon : SoundOnIcon}
          alt={isMuted ? "소리 끄기" : "소리 켜기"}
        />
      </SoundButton>
    </>
  );
};

const YouTubeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;

  background: var(--Light-Scheme-Monochrome-offblack, #505363);

  overflow: hidden;
`;

const SoundButton = styled.button`
  position: absolute;
  top: 0;
  right: 8px;
  z-index: 100;

  width: 56px;
  height: 56px;

  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition: background 0.3s ease;
  pointer-events: auto;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  img {
    width: 42px;
    height: 42px;
  }
`;

const CustomYoutube = styled(YouTube)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;
